<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <div role="button" class="btn"
          :class="[!savedNote.selected && 'is-inactive', ga.noteSaveClass]"
          @click="savedNote.clickSubmit"
        >保存
        </div>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">ノートの選択</span>
        </div>
        <div class="popup-content">
          <div class="popup-content-01">
            <span role="button" class="txt-blue"
              @click="openCreateNote"
            >新規ノートを作成して保存する</span>
          </div>
          <div class="popup-content-02">
            <div class="popup-content-hdg">
              <p class="hdg04 mb20">保存先のノートを選ぶ</p>
            </div>
            <template v-if="!state.isNoteListLoaded">
              <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt20 mb20 icn fa-spin" />
            </template>
            <template v-else>
              <p v-if="savedNote.lists.length == 0">選択できるノートがありません。</p>
              <form v-else @submit.prevent id="note_select_save">
                <div class="popup-content-body">
                    <div class="formparts function suggest">
                      <input 
                        @keydown.enter.prevent="savedNote.clickSearchNote"
                        type="text" 
                        placeholder="ノートのタイトル" 
                        v-model="savedNote.searchKeyword"
                      >
                      <div @click="savedNote.clickSearchNote" 
                        class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
                      <ul v-if="savedNote.lists.length > 0" class="suggest-list">
                        <li v-for="(list, index) in savedNote.lists"
                          :key="'saved_' + list.id"
                          @click="savedNote.clickList(list)"
                          role="option">
                          <div class="formparts" :class="{'radio': list.id !== 0}">
                            <input type="radio" name="target_note" :id="'note_' + index">
                            <label :for="'note_' + index">{{list.title}}</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                </div>
              </form>
            </template>
          </div>
          <div
            v-if="state.isNoteListLoaded && savedNote.lists.length > 0"
            class="popup-content-03">
            <p class="hdg04 mb20">見出し</p>
            <div class="formparts text">
              <input @keydown.enter.prevent type="text" placeholder="見出しを入力" v-model="savedNote.heading">
            </div>
            <p class="hdg04 mb20">コメント</p>
            <div class="formparts textarea">
              <textarea rows="5" placeholder="コメントを入力" v-model="savedNote.comment"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import { SelectNote } from '@/logic/common/SelectNote'

export default defineComponent({
  props: {
    type: {
      type: String,
      default: ''
    },
    pageId: {
      type: Number,
      default: null
    },
    note_row_id: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    currentNoteId: {
      type: Number,
      default: null
    }
  },
  setup (props, context) {

    const openCreateNote = () => {
      context.emit('closeSelectNote')
      context.emit('openCreateNote')
    }

    return {
      openCreateNote,
      ...SelectNote(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 0!important;
  &-01 {
    padding: 20px;
    background-color: #F9F8F6;
    border-bottom: 1px solid $color-line;
    text-align: center;
    .txt-blue {
      font-size: 1.4rem;
    }
  }
  &-02 {
    padding: 20px;
    .suggest-list {
      max-height: 124px;
    }
  }
  &-03 {
    margin-top: 20px;
    padding: 20px;
    border-top: 1px solid #E2E2E2;
    .formparts {
      & + .hdg04 {
        margin-top: 20px;
      }
    }
  }
  &-hdg {
    position: relative;
    &-sup {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate3d(0,-50%,0);
      .small {
        vertical-align: middle;
        color: $color-sup;
        font-size: 1.2rem;
      }
      .large {
        margin: 0 10px;
        vertical-align: middle;
        font-size: 2.4rem;
        font-weight: bold;
      }
    }
  }
  &-body {
    background-color: #fff;
    .hdg04 {
      margin-bottom: 20px;
    }
    &-item {
      padding: 30px 40px;
      border-bottom: 1px solid $color-line;
      &:last-child {
        border-bottom: 0;
      }
      &-03 {
        .txt-blue {
          font-size: 1.4rem;
          @include hoverOpacity;
          .up {
            display: none;
          }
          &.is-open {
            .up {
              display: inline;
            }
            .down {
              display: none;
            }
          }
        }
        .tags-history {
          padding-bottom: 20px;
          border-bottom: 1px solid $color-line;
        }
      }
    }
  }
  .btn[type="submit"] {
    margin: 0 auto;
    width: 230px;
  }
}

</style>
